import { styled } from '@linaria/react';

import { normalize } from '@/utils';

import Demo, { DemoSliderControl } from '@/components/Demo';
import Paper from '@/components/Paper';
import CodeSnippetProvider from '@/components/CodeSnippet/CodeSnippetProvider';

import { CODE_BACKGROUND } from './index.constants';
import {
  INITIAL_WIDTH,
  INITIAL_HEIGHT,
  constructSnippet,
} from './GridIssueExplained.helpers';
import Element from './Element';

function GridIssueExplained({ codeOutput }) {
  return (
    <Demo
      initialValues={{
        width: INITIAL_WIDTH,
        height: INITIAL_HEIGHT,
      }}
      controlPosition="top"
      customGrid={{ gridTemplateColumns: '1fr 1fr' }}
      outputWrapper={null}
      controls={[
        <DemoSliderControl
          key="width"
          id="width"
          label="Element width"
          min={0}
          max={100}
          previewRenderer={(val) => `${val}%`}
        />,
        <DemoSliderControl
          key="height"
          id="height"
          label="Element height"
          min={0}
          max={100}
          previewRenderer={(val) => `${val}%`}
        />,
      ]}
    >
      {({ width, height }) => {
        const heightAdditive = normalize(height, 0, 100, 8, 0);

        return (
          <Row>
            <Column>
              <CodeSnippetProvider
                lang="css"
                code={constructSnippet(width, height)}
              >
                {codeOutput}
              </CodeSnippetProvider>
            </Column>
            <DemoColumn>
              <Container>
                <GridRow />
                <GridColumn />
                <ChildElement
                  style={{
                    width: width + '%',
                    height: `calc(${height}% + ${heightAdditive}px)`,
                    lineHeight: '1.75rem',
                  }}
                >
                  .element
                </ChildElement>
              </Container>
            </DemoColumn>
          </Row>
        );
      }}
    </Demo>
  );
}

const Row = styled.div`
  display: flex;
  gap: 24px;
  padding-bottom: 16px;

  @media (max-width: 34rem) {
    flex-direction: column-reverse;
  }
`;
const Column = styled.div`
  position: relative;
  flex: 1;
  background: ${CODE_BACKGROUND};
  border-radius: 8px;
  width: 100%;
`;

const DemoColumn = styled(Column)`
  display: flex;
  justify-content: center;
  align-self: start;
`;

const Container = styled(Paper)`
  display: grid;
  place-content: center;
  position: relative;
  width: 100%;
  padding: 16px 0px;
  height: 286px;
  overflow: hidden;
  overflow: clip;
`;

const GridTrack = styled.div`
  --border: 3px dashed hsl(345deg 100% 50%);
  position: absolute;
  margin: auto;
  transition: opacity 500ms;
`;

const GridRow = styled(GridTrack)`
  inset: 0 auto;
  width: 100%;
  height: 2.0625rem;
  outline: var(--border);
`;

const GridColumn = styled(GridTrack)`
  inset: auto 0;
  width: 5.4375rem;
  height: 100%;
  outline: var(--border);
`;

const ChildElement = styled(Element)`
  width: 50%;
  height: 50%;

  && {
    padding: 0;
  }
`;

export default GridIssueExplained;
